<div
	class="rx-banner-container"
	[class]="type"
	[class.rx-banner-container--intuitive]="isIntuitiveAppearance"
	[class.rx-banner-container--offline-rich]="isRichNotification"
	[attr.role]="isRichNotification ? 'status' : null"
	[attr.aria-live]="isRichNotification ? 'polite' : null"
>
	<div *ngIf="showOfflineIcon" class="rx-banner-container__offline-icon" aria-hidden="true">
		<tlk-cloud-offline-icon class="tlk-icon_size_l" />
	</div>
	<ng-container *ngIf="isRichNotification; else simpleMessage">
		<div class="rx-banner-container__content">
			<p *ngIf="title" class="banner-message banner-message--title">{{ title }}</p>
			<p *ngIf="message" class="banner-message banner-message--body">{{ message }}</p>
		</div>
	</ng-container>
	<ng-template #simpleMessage>
		<div class="banner-message">{{ message }}</div>
	</ng-template>
</div>
